import { settlementCenter } from './modules/settlementCenter'
import { splitPaymentConfiguration } from './modules/splitPaymentConfiguration'
const SplitAccountingLayOut = () => import(/*webpackChunkName:'sale'*/'@/page/split-accounting/splitAccountingLayOut.vue')
export const splitAccounting={
    path:'/split-accounting',
    component:SplitAccountingLayOut,
    redirect:'/main/split-accounting/config/split',
    // redirect:'/main/split-accounting/config/withdrawal',
    children:[
        settlementCenter,
        splitPaymentConfiguration
    ]
}